// Mock data per RS Igienizzazione Canali

export const companyInfo = {
  name: "RS Igienizzazione Canali",
  tagline: "Il vostro partner di fiducia per la pulizia e sanificazione dei sistemi di aerazione e HVAC",
  logo: "https://customer-assets.emergentagent.com/job_hvac-sanitize/artifacts/k26qi7ih_RS%20Iggenizzazione%20canali%20trasparente.png",
  logoScrolled: "https://customer-assets.emergentagent.com/job_hvac-sanitize/artifacts/9xmdi8j1_RS%20Iggenizzazione%20canali%20trasparente%20%282%29.png",
  email: "spaghettifabrizio1@gmail.com",
  phone: "+39 348 278 1017",
  certifications: ["AIISA", "NADCA"]
};

export const services = [
  {
    id: 1,
    title: "Pulizia Meccanica Canali e UTA",
    description: "Utilizziamo attrezzature all'avanguardia per rimuovere polvere, detriti e contaminanti dai canali di aerazione e dalle Unità di Trattamento Aria, migliorando il flusso d'aria e l'efficienza del sistema.",
    icon: "Wind"
  },
  {
    id: 2,
    title: "Sanificazione Chimica e Biologica",
    description: "Eliminazione di batteri, muffe e virus dai sistemi di aerazione utilizzando prodotti certificati e soluzioni biologiche per garantire la salubrità dell'aria.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Controllo e Manutenzione Periodica",
    description: "Programmi di manutenzione personalizzati per garantire il funzionamento ottimale dei sistemi HVAC e prevenire guasti.",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Ispezioni con Telecamere Robotizzate",
    description: "Ispezioni dettagliate all'interno dei canali di aerazione per identificare e risolvere problemi nascosti senza interventi invasivi.",
    icon: "Camera"
  },
  {
    id: 5,
    title: "Rimozione e Prevenzione Muffe",
    description: "Interventi per rimuovere la muffa dai sistemi HVAC e implementare misure preventive per evitare la sua ricomparsa.",
    icon: "Droplets"
  },
  {
    id: 6,
    title: "Certificazioni di Conformità",
    description: "Al termine di ogni intervento, rilasciamo una certificazione che attesta l'avvenuta sanificazione e la conformità agli standard igienici.",
    icon: "Award"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Riduzione Costi Energetici",
    description: "Un sistema HVAC pulito può ridurre il consumo energetico del 15-20%, funzionando in modo più efficiente.",
    stat: "15-20%",
    statLabel: "Risparmio energetico",
    source: "EPA - Environmental Protection Agency"
  },
  {
    id: 2,
    title: "Aumento Vita Utile Impianto",
    description: "La manutenzione regolare può prolungare la vita degli impianti HVAC del 30-50%, riducendo l'usura e prevenendo guasti.",
    stat: "30-50%",
    statLabel: "Durata prolungata",
    source: "Building Efficiency Initiative"
  },
  {
    id: 3,
    title: "Riduzione Costi Riparazione",
    description: "Un programma di manutenzione preventiva può ridurre i costi di riparazione fino al 40%.",
    stat: "40%",
    statLabel: "Risparmio riparazioni",
    source: "ASHRAE"
  },
  {
    id: 4,
    title: "Miglioramento Qualità dell'Aria",
    description: "Una cattiva qualità dell'aria interna può aumentare l'assenteismo fino al 10%. Sistemi puliti riducono malattie respiratorie.",
    stat: "10%",
    statLabel: "Riduzione assenteismo",
    source: "OMS - Organizzazione Mondiale della Sanità"
  }
];

export const healthBenefits = [
  {
    id: 1,
    title: "Riduzione Malattie Respiratorie",
    description: "Un sistema HVAC ben mantenuto riduce la concentrazione di inquinanti come polvere, muffa e allergeni, diminuendo l'incidenza di problemi respiratori come asma e allergie."
  },
  {
    id: 2,
    title: "Prevenzione Sindrome Edificio Malato",
    description: "Migliorare la qualità dell'aria previene sintomi come mal di testa, affaticamento e irritazione delle vie respiratorie tipici della Sindrome dell'Edificio Malato (SBS)."
  },
  {
    id: 3,
    title: "Controllo Umidità e Muffe",
    description: "Mantenere livelli di umidità ottimali (30-60%) previene la crescita di muffe e funghi, supportando i meccanismi di difesa naturali del corpo."
  },
  {
    id: 4,
    title: "Prevenzione Legionella",
    description: "Un sistema HVAC ben mantenuto riduce drasticamente il rischio di proliferazione della Legionella, proteggendo la salute degli occupanti degli edifici."
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Videoispezione e Raccolta Campioni",
    description: "Eseguiamo una videoispezione iniziale dei canali e delle UTA, raccogliamo campioni batteriologici e forniamo una relazione dettagliata sui risultati."
  },
  {
    id: 2,
    title: "Pulizia e Sanificazione",
    description: "Puliamo i canali utilizzando tecniche meccaniche avanzate ed eseguiamo la sanificazione chimica e biologica per eliminare tutti i contaminanti."
  },
  {
    id: 3,
    title: "Verifica e Certificazione",
    description: "Effettuiamo una nuova videoispezione, raccogliamo campioni per verificare l'efficacia e rilasciamo la certificazione finale di conformità."
  }
];

export const legislativeReferences = [
  {
    title: "D.Lgs. 81/08 - Testo Unico Sicurezza",
    description: "Il datore di lavoro è tenuto a valutare tutti i rischi, compresa la qualità dell'aria interna. L'articolo 64 richiede che gli impianti di aerazione siano mantenuti in condizioni di igiene adeguate."
  },
  {
    title: "DPR 74/2013",
    description: "Regola la manutenzione degli impianti di climatizzazione, definendo le operazioni per garantire efficienza energetica e sicurezza, inclusa la pulizia periodica dei canali."
  },
  {
    title: "Normative Regionali Lazio",
    description: "Le aziende devono garantire che i sistemi di aerazione siano mantenuti in condizioni ottimali per evitare la proliferazione di agenti patogeni."
  },
  {
    title: "Standard ASHRAE",
    description: "Standard globalmente riconosciuti per la progettazione, manutenzione e pulizia degli impianti HVAC, utilizzati come riferimento in Italia e Europa."
  }
];

export const whyChooseUs = [
  {
    title: "Salute e Benessere",
    description: "Riduciamo allergeni, batteri e muffe, prevenendo problemi di salute e migliorando la produttività dei dipendenti."
  },
  {
    title: "Conformità Normativa",
    description: "Rispettare il D.Lgs. 81/08 è fondamentale. La nostra certificazione AIISA garantisce interventi conformi agli standard legislativi."
  },
  {
    title: "Certificazioni di Eccellenza",
    description: "Siamo certificati AIISA (Associazione Italiana Igienisti Sistemi Aeraulici) e rispettiamo tutte le normative in materia di sicurezza."
  },
  {
    title: "Efficienza Economica",
    description: "Sistemi puliti riducono consumi energetici e costi operativi. La manutenzione previene guasti e prolunga la vita degli impianti."
  }
];
